import React from "react";
import { useSearchParams, useNavigate, Link as RouterLink } from "react-router-dom";
import { Box, Typography, Paper, Button, Alert } from "@mui/material";
import CouponFormDialog from "../Components/CouponFormDialog";
import { COUPON_CONFIG } from "../constants/couponConstants";

/**
 * Standalone claim coupon page so the camera is not held by the QR scanner.
 * Opened from scanning page with ?id=...&role=...
 * On success or cancel, redirect back to scanning-visitors.
 */
export default function ClaimCouponPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const id = searchParams.get("id") || "";
  const role = searchParams.get("role") || "";

  const goBackToScanner = () => {
    if (window.opener) {
      window.close();
    } else {
      navigate("/scanning-visitors", { replace: true });
    }
  };

  const isValidityExpired = () =>
    new Date() > new Date(COUPON_CONFIG.VALIDITY_END_DATE);

  if (!id || !role) {
    return (
      <Box sx={{ p: 3 }}>
        <Paper sx={{ p: 3 }}>
          <Typography color="text.secondary">
            Missing scan data. Please scan a badge from the scanning page first.
          </Typography>
          <Typography
            component={RouterLink}
            to="/scanning-visitors"
            sx={{ mt: 2, display: "block", color: "primary.main", textDecoration: "none" }}
          >
            Go to Scan Visitors
          </Typography>
        </Paper>
      </Box>
    );
  }

  if (isValidityExpired()) {
    return (
      <Box sx={{ p: 3 }}>
        <Paper sx={{ p: 3 }}>
          <Alert severity="info" sx={{ mb: 2 }}>
            The coupon redemption validity period has expired. You can no longer claim this coupon.
          </Alert>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            The offer was valid until {new Date(COUPON_CONFIG.VALIDITY_END_DATE).toLocaleDateString()}. Please check back for future promotions.
          </Typography>
          <Button variant="contained" color="primary" onClick={goBackToScanner}>
            Go Back to Scanner
          </Button>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ py: 2 }}>
      <CouponFormDialog
        open={true}
        onClose={goBackToScanner}
        scannedData={id}
        scannedRole={role}
        onSuccess={goBackToScanner}
      />
    </Box>
  );
}
